import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import { QueuedJobsHandler } from "../QueuedJobsHandler";
export var ErrorCheckoutTypes;

(function (ErrorCheckoutTypes) {})(ErrorCheckoutTypes || (ErrorCheckoutTypes = {}));

export var CheckoutQueuedJobs =
/*#__PURE__*/
function (_QueuedJobsHandler) {
  _inherits(CheckoutQueuedJobs, _QueuedJobsHandler);

  function CheckoutQueuedJobs() {
    _classCallCheck(this, CheckoutQueuedJobs);

    return _possibleConstructorReturn(this, _getPrototypeOf(CheckoutQueuedJobs).apply(this, arguments));
  }

  return CheckoutQueuedJobs;
}(QueuedJobsHandler);